import * as React from 'react';
import {ACTION_DISPLAY_TYPES} from '../../../ActionsManager/ActionsManagerConsts';
import {EBAY_LISTINGS_ACTIONS_TYPES} from '../../../ActionsManager/ActionsTypes';
import EbayListingsActions from '../../../ActionsManager/EbayListingsActions/EbayListingsActions';
import EndingReasonSelect from '../DialogComponents/EndingReasonSelect';
import FormDialog, {SpecificFormDialogProps} from 'cl-dialogs/FormDialog';
import {ListingsApiRequestOptions} from 'cl-api';

interface EndListingsFormData {
  endingReason: ListingsApiRequestOptions.EndingReasonEnum;
}

type EndListingsDialogProps = SpecificFormDialogProps<
  EndListingsFormData,
  {ebayListingsIds: string[]; initialEndingReason: ListingsApiRequestOptions.EndingReasonEnum}
>;

export default class EndListingDialog extends React.PureComponent<EndListingsDialogProps> {
  render() {
    const {ebayListingsIds, initialEndingReason, ...props} = this.props;
    return (
      <FormDialog<EndListingsFormData>
        formName={EBAY_LISTINGS_ACTIONS_TYPES.END_LISTINGS}
        initialValues={{endingReason: initialEndingReason}}
        title="End Listings"
        text={
          <React.Fragment>
            Are you sure you want to end these listings on eBay?
            <br />
            Doing so will make it unavailable for your customers.
            <br />
            Ended listings are NOT deleted from CrazyLister.
            <br />
          </React.Fragment>
        }
        fields={[{component: EndingReasonSelect, name: 'endingReason', label: 'Reason for ending your listings'}]}
        actions={
          <EbayListingsActions
            types={[EBAY_LISTINGS_ACTIONS_TYPES.END_LISTINGS]}
            displayType={ACTION_DISPLAY_TYPES.FLAT_BUTTON}
            listingsIds={ebayListingsIds}
            lastActionColor="error"
          />
        }
        {...props}
      />
    );
  }
}
